var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1492_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16665 10.6667H9.83331C10.2 10.6667 10.5 10.3667 10.5 10V6.66667H11.56C12.1533 6.66667 12.4533 5.94667 12.0333 5.52667L8.97331 2.46667C8.71331 2.20667 8.29331 2.20667 8.03331 2.46667L4.97331 5.52667C4.55331 5.94667 4.84665 6.66667 5.43998 6.66667H6.49998V10C6.49998 10.3667 6.79998 10.6667 7.16665 10.6667ZM4.49998 12H12.5C12.8666 12 13.1666 12.3 13.1666 12.6667C13.1666 13.0333 12.8666 13.3333 12.5 13.3333H4.49998C4.13331 13.3333 3.83331 13.0333 3.83331 12.6667C3.83331 12.3 4.13331 12 4.49998 12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1492_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.014ba318c418553d74e8b8357ac0d19c.svg";
export { ForwardRef as ReactComponent };